/** @jsx isolateComponent */
import { Fragment } from 'react';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Spacer } from '@zapier/design-system';
import Section from '../Section';
import Container from '../Container';
/**
 * A component to consistent styling for the hello header at the top of some screens
 */
const HelloSection = ({ size = 'small', title = '', detailText, containerPaddingTop = 0, containerPaddingBottom = 0, containerPaddingLeft = 0, containerPaddingRight = 0, }) => {
    return (isolateComponent(Container, { paddingBottom: containerPaddingBottom, paddingLeft: containerPaddingLeft, paddingRight: containerPaddingRight, paddingTop: containerPaddingTop },
        isolateComponent(Section
        // Rebranded styles show this heading smaller than the others, so always use smallest size for this. Affects heading font size.
        , { 
            // Rebranded styles show this heading smaller than the others, so always use smallest size for this. Affects heading font size.
            size: size, title: title },
            isolateComponent(Spacer, { height: detailText ? 10 : 20 }),
            detailText && (isolateComponent(Fragment, null,
                isolateComponent("p", null, detailText),
                isolateComponent(Spacer, { height: 10 }))))));
};
export default HelloSection;
